import { render } from "./PersonOverview.vue?vue&type=template&id=73be10ad"
import script from "./PersonOverview.vue?vue&type=script&lang=js"
export * from "./PersonOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__